import { React, useEffect, useState, useRef, forwardRef, useImperativeHandle } from 'react';
import styled from 'styled-components';
import moment from 'moment';

import FetchModule from '../../Share/Network/FetchModule';
import { useLanguage } from '../../../Context/LanguageContext';
import { useTheme } from '../../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../../Styles/theme';

import NewTitleInput from '../../../Component/NoticeComponent/NewTitleInput';
import NewTextArea from '../../../Component/NoticeComponent/NewTextArea';
import NotRegistrationCardModal from '../../Share/Normal/NotRegistrationCardModal';
import ImageEditModal from './ImageEditModal';

import NoticePictureIcon from '../../../image/NoticePictureIcon.png';
import WhiteExitIcon from '../../../image/WhiteExitIcon.png';
import URLIcon from '../../../image/URLIcon.png';
import KakaoTalkSpeechBubbleIcon from '../../../image/KakaoTalkSpeechBubbleIcon.png';
import { ReactComponent as PinIconSvg } from '../../../image/Pin.svg';
import { ReactComponent as CameraIcon } from '../../../image/Camera.svg';
import WhitePencelIcon from '../../../image/WhitePencelIcon.png';

const NewNoticeCreateBox = forwardRef((props, ref) => {
  const { t } = useLanguage();
  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;

  const [value, setValue] = useState('');
  const [picture, setPicture] = useState(undefined);
  const [countData, setCountData] = useState({ isRegistrationCard: false, validCount: 0, invalidCount: 0 });
  const [storeLogo, setStoreLogo] = useState('');

  const [isClickedEditPhoto, setIsClickedEditPhoto] = useState(false);
  const [pictureIndex, setPictureIndex] = useState(0);
  const [pictures, setPictures] = useState([]);
  const [pictureWidth, setPictureWidth] = useState(0);
  const [pictureHeight, setPictureHeight] = useState(0);

  const [isClickedKakaoBiz, setIsClickedKakaoBiz] = useState(false);
  const [isClickedValid, setIsClickedValid] = useState(false);
  const [isClickedInvalid, setIsClickedInvalid] = useState(false);

  const [isViewRegistrationCard, setIsViewRegistrationCard] = useState(false);

  const [urls, setUrls] = useState([]);

  const [isNeedCheckURL, setIsNeedCheckURL] = useState(false);
  const [isClickedFixed, setIsClickedFixed] = useState(false);
  const [alimtalkPrice, setAlimtalkPrice] = useState(10);

  const TitleRef = useRef();
  const CanvasRef = useRef();
  const hiddenFileInput = useRef(null);
  const FileInputRef = useRef();

  useImperativeHandle(ref, () => ({
    getTitle: () => {
      return TitleRef.current.getValue();
    },
    getValue: () => {
      let fianlURL = '';

      for (let i = 0; i < urls.length; i++) {
        fianlURL += (urls[i] + ' ');
      }

      return value + '\n' + fianlURL;
    },
    getPicture: () => {
      let pictureList = [];

      for (let i = 0; i < pictures.length; i++) {
        pictureList.push(pictures[i].edit);
      }

      return pictureList;
    },
    getIsClickedKakaoBiz: () => {
      return isClickedKakaoBiz;
    },
    getIsClickedValid: () => {
      return isClickedValid;
    },
    getIsClickedInvalid: () => {
      return isClickedInvalid;
    },
    getIsFixed: () => {
      return isClickedFixed;
    }
  }))

  useEffect(() => {
    if (!isNeedCheckURL) return;

    let newContent = value;
    let newUrls = urls.slice();

    while (true) {
      let url = collectURL(newContent);

      if (url === '') break;
      else {
        newContent = newContent.replace(url, '');
        newUrls.push(url.replaceAll(',', ''));
      }
    }

    setUrls(newUrls);
    setValue(newContent);
    setIsNeedCheckURL(false);
  }, [value, urls, isNeedCheckURL])

  // 회원수 불러오기 //
  useEffect(() => {
    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.getDataVersion2('member/count', 'GET');

        if (responseData.status === 200) {
          setStoreLogo(responseData.data.storeLogo);
          setCountData(responseData.data);
        }
      }
    )();
  }, [])

  // 메세지 단가 조회 //
  useEffect(() => {
    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.getDataVersion2('message/pricing', 'GET');

        if (responseData.status === 200) {
          let alimtalk = responseData.data.find((item) => item.messageType === 'ALIMTALK');
          if (alimtalk) setAlimtalkPrice(alimtalk.unitPrice);
        }
      }
    )();
  }, [])

  const onClickImage = e => {
    hiddenFileInput.current.click();
  };

  const onChangeImage = e => {

    const pathpoint = e.target.value.lastIndexOf('.');
    const filepoint = e.target.value.substring(pathpoint + 1, e.target.length);
    const filetype = filepoint.toLowerCase();

    if (filetype === 'jpg' || filetype === 'png' || filetype === 'jpeg') {

      // 정상적인 이미지 확장자 파일인 경우
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64 = reader.result;
        const naturalImage = new Image();

        naturalImage.src = reader.result.toString();

        naturalImage.onload = function (e) {

          let naturalWidth = e.target.naturalWidth;
          let naturalHeight = e.target.naturalHeight;

          let resizeWidth = 0;
          let resizeHeight = 0;

          if (naturalWidth < 1080) {
            resizeWidth = naturalWidth;
            resizeHeight = naturalHeight;
          }
          else {
            resizeWidth = 1080;
            resizeHeight = (1080 * naturalHeight) / naturalWidth;
          }


          let finalHeight = (resizeHeight * 368) / resizeWidth;

          setPictureWidth(368);
          setPictureHeight(finalHeight);

          const image = new Image();
          const canvas = CanvasRef.current;
          const ctx = canvas?.getContext('2d');

          if (ctx) {
            if (naturalWidth > 1080) {
              canvas.width = resizeWidth;
              canvas.height = resizeHeight;
              image.src = base64.toString();

              // 사진 크기 조정후 Canvas에 그리기 //
              image.onload = function () {
                ctx.clearRect(0, 0, canvas.width, canvas.height);
                ctx.drawImage(image, 0, 0, resizeWidth, resizeHeight);
              }

              // 크기 조절된 사진 데이터 정리하기 //
              canvas.toBlob(function (blob) {
                const reader = new FileReader();
                // Canvas에 다 그려졌을때 Event //
                reader.onload = function (e) {
                  setPicture({ original: base64.toString(), edit: canvas.toDataURL(), division: 'Original' });
                  setPictures([...pictures, { original: base64.toString(), edit: canvas.toDataURL(), division: 'Original' }]);
                  setPictureIndex(pictures.length);
                }
                reader.readAsDataURL(blob);
              })
            }
            else {
              setPicture({ original: base64.toString(), edit: base64.toString(), division: 'Original' });
              setPictures([...pictures, { original: base64.toString(), edit: base64.toString(), division: 'Original' }]);
              setPictureIndex(pictures.length);
            }
          }
          else {
            alert(t('noticePage.alertInvalidFile'));
          }
        }
      };
      if (e.target.files[0]) {
        reader.readAsDataURL(e.target.files[0]);
      }
    }
    else {
      alert(t('noticePage.alertInvalidFileType'));
    }
  };

  // 사진 삭제 버튼 클릭시 //
  function onClickDeletePicture() {
    if (pictureIndex !== 0) {
      let img = document.createElement('img');
      img.src = pictures[pictureIndex - 1].edit;

      img.onload = () => {
        let finalWidth = 368;
        let finalHeight = (img.height * finalWidth) / img.width;

        setPictureWidth(finalWidth);
        setPictureHeight(finalHeight);
      }

      setPicture(pictures[pictureIndex - 1]);
      setPictureIndex(pictureIndex - 1);

    }

    let tmpPictures = [...pictures];

    tmpPictures.splice(pictureIndex, 1);

    setPictures(tmpPictures);

    if (tmpPictures.length === 0) setIsClickedEditPhoto(false);
  }

  // 붙여넣기나 스페이스바, 엔터키 감지시 URL 체크 //
  function onCheckURL() {
    setTimeout(() => {
      setIsNeedCheckURL(true);
    }, 100);
  }

  // 공지사항내에 링크 추출 //
  function collectURL(text) {
    let urlRegex = /(https?:\/\/[^ ]*)/;
    let url = text.match(urlRegex) === null ? '' : text.match(urlRegex)[1];

    return url;
  }

  // 링크 클릭시 //
  function onClickURL(url) {
    window.open(url, "_blank", "noreferrer");
  }

  // URL 삭제 클릭시 //
  function onClickDeleteURL(index) {
    let newURLs = urls.slice();

    newURLs.splice(index, 1);
    setUrls(newURLs);
  }

  // 유튜브링크인지 확인 //
  function decideYoutubeLink(url) {
    if (!url.includes('https://youtu.be/') && !url.includes('https://www.youtube.com/watch?v=')) {
      return false;
    }
    else if (url.includes('https://youtu.be/')
      && (url.split('https://youtu.be/')[0] !== '' || url.split('https://youtu.be/')[1] === '')) {
      return false;
    }
    else if (url.includes('https://www.youtube.com/watch?v=')
      && (url.split('https://www.youtube.com/watch?v=')[0] !== '' || url.split('https://www.youtube.com/watch?v=')[1] === '')) {
      return false;
    }
    else return true;
  }

  // 유튜브링크인지 확인후 Id 만 추출 //
  function decideYoutubeLinkVideoId(url) {
    if (url.includes('https://youtu.be/')) return url.replace('https://youtu.be/', '');
    else if (url.includes('https://www.youtube.com/watch?v=')) return url.replace('https://www.youtube.com/watch?v=', '')
  }

  // 카카오 알림톡 발송 회원수 결정 //
  function decideMemberCount() {
    if (isClickedValid && isClickedInvalid) return (countData.validCount + countData.invalidCount).toLocaleString('ko-KR');
    else if (isClickedValid) return countData.validCount.toLocaleString('ko-KR');
    else if (isClickedInvalid) return countData.invalidCount.toLocaleString('ko-KR');
    else return 0;
  }

  // 카카오 알림톡 발송 회원수에 따른 발송 금액 계산 //
  function decideCalcKakaoBizPrice() {
    if (isClickedValid && isClickedInvalid) return ((countData.validCount + countData.invalidCount) * alimtalkPrice).toLocaleString('ko-KR');
    else if (isClickedValid) return (countData.validCount * alimtalkPrice).toLocaleString('ko-KR');
    else if (isClickedInvalid) return (countData.invalidCount * alimtalkPrice).toLocaleString('ko-KR');
    else return 0;
  }

  // 카카오 알림톡 버튼 클릭시 //
  function onClickKakaoBiz() {
    // 카드번호 입력이 안되어있는 경우 //
    if (!countData.isRegistrationCard) {
      // 모달 표출 //
      setIsViewRegistrationCard(true);
    }
    else {
      setIsClickedKakaoBiz(!isClickedKakaoBiz);
    }
  }

  // 입력하기 버튼 클릭시 //
  function onClickRegistrationCard() {
    const obj = {};

    obj.PCD_PAY_TYPE = 'card'
    obj.PCD_PAY_WORK = 'AUTH'
    obj.PCD_CARD_VER = '01';
    obj.PCD_PAYER_AUTHTYPE = 'sms';

    obj.callbackFunction = getResult;
    obj.clientKey = '0F44C92BFB07F1BE60C5235A7254316D';

    window.PaypleCpayAuthCheck(obj);
  }

  // 결제 이후 콜백 //
  function getResult(res) {
    if (res.PCD_PAY_RST === 'success' && (res.PCD_PAY_CODE === '0000' || res.PCD_PAY_CODE === 'CDAU1000')) {
      let requestData = {
        billingKey: res.PCD_PAYER_ID,
        cardName: res.PCD_PAY_CARDNAME,
        cardNum: res.PCD_PAY_CARDNUM
      }
      const fetchModule = new FetchModule();
      (
        async () => {
          const responseData = await fetchModule.postDataVersion2('billing/registry', 'POST', requestData);

          if (responseData.status === 200) {
            alert(t('noticePage.alertCardRegistered'));
            setCountData({ isRegistrationCard: true, validCount: countData.validCount, invalidCount: countData.invalidCount });
            setIsViewRegistrationCard(false);
          }
          else if (responseData.status === 201) {
            alert(t('noticePage.alertAlreadyRegistered'));
            setIsViewRegistrationCard(false);
          }
        }
      )();
    }
    else {
      if (res.PCD_PAY_CODE === undefined) {
        alert(res.PCD_PAY_MSG);
      }
      else {
        alert('[' + res.PCD_PAY_CODE + ']' + ' ' + res.PCD_PAY_MSG);
      }
    }
  }

  // 사진 이전 버튼 클릭시 //
  function onClickPrevPicture() {
    if (pictureIndex > 0) {
      let img = document.createElement('img');
      img.src = pictures[pictureIndex - 1].edit;
      
      img.onload = () => {
        let finalWidth = 368;
        let finalHeight = (img.height * finalWidth) / img.width;

        setPictureWidth(finalWidth);
        setPictureHeight(finalHeight);
      }

      setPicture(pictures[pictureIndex - 1]);
      setPictureIndex(pictureIndex - 1);
    }
  }

  // 사진 다음 버튼 클릭시 //
  function onClickNextPicture() {
    if (pictureIndex < pictures.length - 1) {
      let img = document.createElement('img');
      img.src = pictures[pictureIndex + 1].edit;

      img.onload = () => {
        let finalWidth = 368;
        let finalHeight = (img.height * finalWidth) / img.width;

        setPictureWidth(finalWidth);
        setPictureHeight(finalHeight);
      }

      setPicture(pictures[pictureIndex + 1]);
      setPictureIndex(pictureIndex + 1);
    }
  }

  return (
    <TopLevelWrapper>
      { isViewRegistrationCard && <NotRegistrationCardModal division='Notice' setIsViewModal={setIsViewRegistrationCard} onClickRegistCard={onClickRegistrationCard} />}
      { 
        isClickedEditPhoto && 
        <ImageEditModal
          picture={picture}
          setPicture={setPicture}
          pictures={pictures}
          setPictures={setPictures}
          pictureIndex={pictureIndex}
          setPictureIndex={setPictureIndex}
          setNoEditPictureWidth={setPictureWidth}
          setNoEditPictureHeight={setPictureHeight}
          onClickExit={() => setIsClickedEditPhoto(false)}
          onClickPrevPicture={onClickPrevPicture}
          onClickNextPicture={onClickNextPicture}
          onClickDeletePicture={onClickDeletePicture}/> 
      }
      <ViewWrapper isDark={isDark}>
        <ComponentWrapper>
          <DateTitleWrapper>
            <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} cursor='default'>{moment().format(t('noticePage.dateFormat'))}</Text>
            <FixingButton isClicked={isClickedFixed} onClick={() => setIsClickedFixed(!isClickedFixed)}>
              <FixingWrapper opacity={isClickedFixed ? 0 : 1}>
                <PinIcon />
                <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text}>{t('noticePage.pinToTop')}</Text>
              </FixingWrapper>
              <FixingWrapper opacity={isClickedFixed ? 1 : 0}>
                <PinIcon />
                <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.subBackground}>{t('noticePage.pinToTop')}</Text>
              </FixingWrapper>
            </FixingButton>
          </DateTitleWrapper>
          <NewTitleInput ref={TitleRef} storeLogo={storeLogo} placeholder={t('noticePage.titlePlaceholder')} />
        </ComponentWrapper>
        <ComponentWrapper style={{ marginTop: `24px` }}>
          <Title style={{ marginBottom: '8px' }}>{t('noticePage.contentLabel')}</Title>
          <NewTextArea value={value} setValue={setValue} checkURL={onCheckURL} />
        </ComponentWrapper>
        <URLWrapper>
          {
            urls.map((data, index) => (
              decideYoutubeLink(data) ?
                <VideoViewWrapper key={index}>
                  <iframe
                    width="100%"
                    height="100%"
                    src={(decideYoutubeLink(data)) ? `https://www.youtube.com/embed/` + decideYoutubeLinkVideoId(data) : ''}
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    title="Embedded youtube" />
                  <VideoDeleteButtonWrapper onClick={() => onClickDeleteURL(index)} >
                    <DeleteButton margin='10px 10px 0px 0px' width={24} height={24} radius={24}>
                      <Icon src={WhiteExitIcon} width={18} height={18} />
                    </DeleteButton>
                  </VideoDeleteButtonWrapper>
                </VideoViewWrapper>
                :
                <URLTextBox key={index}>
                  <DeleteButton onClick={() => onClickDeleteURL(index)} margin='0px 0px 0px 0px' width={15} height={15} radius={15}>
                    <Icon src={WhiteExitIcon} width={13} height={13} />
                  </DeleteButton>
                  <InnerURLTextBox onClick={() => onClickURL(data)}>
                    <Icon src={URLIcon} />
                    <TextWrapper>
                      <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} cursor='pointer'>{data}</Text>
                    </TextWrapper>
                  </InnerURLTextBox>
                </URLTextBox>
            ))
          }
        </URLWrapper>
        <TotalKakaoSendWrapper>
          <KakaoSendWrapper isClicked={isClickedKakaoBiz}>
            <TotalSendInfoWrapper>
              <SendInfoWrapper gap={16}>
                <CheckBoxWrapper onClick={() => setIsClickedValid(!isClickedValid)}>
                  <SendCheckBox isClicked={isClickedValid} />
                  <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#666666' cursor='pointer'>{t('noticePage.validMember')}</Text>
                </CheckBoxWrapper>
              </SendInfoWrapper>
              <SendInfoWrapper gap={16}>
                <TotalTextWrapper>
                  <SendTextWrapper>
                    <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#666666' cursor='default'>{t('noticePage.kakaoSendInfo', { count: decideMemberCount() })}</Text>
                    <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#000000' cursor='default'>{t('noticePage.kakaoSendPrice', { price: decideCalcKakaoBizPrice() })}</Text>
                  </SendTextWrapper>
                </TotalTextWrapper>
              </SendInfoWrapper>
            </TotalSendInfoWrapper>
            <KakaoSendButton isClicked={isClickedKakaoBiz} onClick={onClickKakaoBiz}>
              <Icon src={KakaoTalkSpeechBubbleIcon} width={26} height={24} style={{ margin: `-1px 0px 0px -3px` }} />
            </KakaoSendButton>
          </KakaoSendWrapper>
        </TotalKakaoSendWrapper>
      </ViewWrapper>
      <canvas ref={CanvasRef} style={{ display: 'none' }} />
      <input
        type="file"
        ref={hiddenFileInput}
        onChange={onChangeImage}
        style={{ display: 'none' }} />
      {
        pictures.length === 0 &&
        <PictureLoadigButton ref={FileInputRef} onClick={onClickImage}>
          <PictureIcon src={NoticePictureIcon} />
        </PictureLoadigButton>
      }
      {
        pictures.length > 0 &&
        <TotalImageWrapper width={pictureWidth} >
          <TotalImageInnerWrapper width={pictureWidth} >
            <ImageWrapper width={pictureWidth} height={pictureHeight}>
              <PictureImage width={pictureWidth} height={pictureHeight} src={picture.edit} />
            </ImageWrapper>

            <ExitButtonWrapper width={pictureWidth} height={pictureHeight}>
              <PictureEditButton onClick={() => setIsClickedEditPhoto(true)}>
                <PictureImage width={18} height={18} src={WhitePencelIcon} />
                <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.white} cursor='pointer'>{t('noticePage.editPhoto')}</Text>
              </PictureEditButton>
              <ExitButton onClick={onClickDeletePicture}>
                <ExitIcon src={WhiteExitIcon} />
              </ExitButton>
            </ExitButtonWrapper>

            <MovePictureButtonWrapper>
              <MoveButton isView={pictureIndex > 0} onClick={onClickPrevPicture}>
                <LeftIcon />
              </MoveButton>
              <MoveButton isView={pictureIndex < pictures.length - 1} onClick={onClickNextPicture}>
                <RightIcon />
              </MoveButton>
            </MovePictureButtonWrapper>
          </TotalImageInnerWrapper>
          {
            pictures.length < 10 &&
            <AddPictureButtonWrapper ref={FileInputRef} onClick={onClickImage}>
              <AddPictureButton>
                <StyledCameraIcon />
                <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} cursor='pointer'>{t('noticePage.addPhoto')}</Text>
              </AddPictureButton>
            </AddPictureButtonWrapper>
          }
        </TotalImageWrapper>
      }
    </TopLevelWrapper>
  )
})

export default NewNoticeCreateBox;

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  width: 1020px;

  gap: 20px;

  margin-top: 38px;
  margin-bottom: 96px;
  padding-bottom: 68px;
`;

const ViewWrapper = styled.div`
  diplay: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  padding-top: 12px;

  border-radius: 30px;
  box-shadow: ${props => props.isDark ? 'none' : '0px 40px 50px rgba(240, 232, 227, 0.5)'};
  background-color: ${props => props.theme.subBackground};
`;

const ComponentWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: flex-start;

  margin: 0px 28px 0px 28px;
`;

const DateTitleWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  width: 100%;
`;

const FixingButton = styled.div`
  display: grid;

  justify-items: center;
  align-items: center;

  padding: 0px 10px;

  height: 28px;

  border-radius: 5px;
  background-color: ${props => props.isClicked ? props.theme.pointRed : props.theme.background};

  transition: all 0.3s ease-in-out;

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const FixingWrapper = styled.div`
  grid-area: 1 / 1;
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 3px;

  white-space: nowrap;

  opacity: ${props => props.opacity};

  transition: all 0.3s ease-in-out;

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const PinIcon = styled(PinIconSvg)`
  width: 16px;
  height: 16px;

  flex-shrink: 0;

  & path {
    fill: ${props => props.theme.text};
    transition: fill 0.3s ease-in-out;
  }
`;

const Title = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 14px;

  margin: 0 0 0 0;

  color: ${props => props.theme.text};
`;

const PictureLoadigButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 55px;
  height: 55px;

  border-radius: 8px;
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.10);
  background-color: ${props => props.theme.subBackground};

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const PictureIcon = styled.img`
  width: 29px;
  height: 29px;
`;

const TotalImageWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: ${props => props.width}px;
`;

const TotalImageInnerWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100%;
`;

const MovePictureButtonWrapper = styled.div`
  position: absolute;
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  padding: 0px 12px;

  width: calc(100% - 24px);
`;

const MoveButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 24px;
  height: 24px;

  border-radius: 24px;
  background-color: #808080;

  opacity: ${props => props.isView ? 1 : 0};

  @media (hover: hover) {
    &:hover {
      cursor: ${props => props.isView ? `pointer` : `default`};
    }
  }

  transition: all 0.3s ease-in-out;
`;

const LeftIcon = styled.div`
  margin-left: -4px;

  width: 0;
  height: 0;
  border-style: solid;
  border-width: 6px 9px 6px 0px;
  border-color: transparent #FFFFFF transparent transparent;
`;

const RightIcon = styled.div`
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 6px 0px 6px 9px;
  border-color: transparent transparent transparent #FFFFFF;
`;

const ImageWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: ${props => props.width}px;
  height: ${props => props.height}px;

  border-radius: 12px;
  
  overflow: hidden;
  
  transition: all 0.3s ease-in-out;
`;

const PictureImage = styled.img`
  width: ${props => props.width}px;
  height: ${props => props.height}px;
`;

const StyledCameraIcon = styled(CameraIcon)`
  width: 20px;
  height: 20px;

  & path {
    fill: ${props => props.theme.text};
  }
`;

const PictureEditButton = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 54px;
  height: 24px;

  gap: 2px;

  border-radius: 5px;
  background-color: rgba(0, 0, 0, 0.60);
`;

const AddPictureButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-end;
  align-items: flex-start;

  margin-top: 20px;

  width: 100%;
`;

const AddPictureButton = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  padding: 6px 12px;

  gap: 4px;

  border-radius: 5px;
  background-color: ${props => props.theme.subBackground};

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const ExitButtonWrapper = styled.div`
  position: absolute;
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: flex-start;

  margin-top: 8px;

  padding: 0px 8px;

  width: calc(368px - 8px);
  height: calc(100% - 8px);
`;

const ExitButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 24px;
  height: 24px;

  border-radius: 24px;
  background-color: rgba(0, 0, 0, 0.6);

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const ExitIcon = styled.img`
  width: 18px;
  height: 18px;
`;

const URLWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  margin: 16px 28px 0px 28px;

  gap: 4px;

  width: 582px;
`;

const URLTextBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  width: 100%;
  height: 24px;

  gap: 8px;

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const InnerURLTextBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  width: calc(100% - 39px);
  height: 24px;

  gap: 8px;

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  width: calc(100% - 26px);
  height: 22px;

  overflow: hidden;
`;

const VideoViewWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-end;

  margin: 10px 0px 10px 0px;
  width: 100%;
  height: 330px;
  
  overflow: hidden;

  border-radius: 8px;
  
  transition: all 0.3s ease-in-out;
`;

const VideoDeleteButtonWrapper = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-end;

  width: 100%;
`;

const DeleteButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  margin: ${props => props.margin};

  width: ${props => props.width}px;
  height: ${props => props.height}px;

  border-radius: ${props => props.radius}px;
  background-color: rgba(0, 0, 0, 0.6);

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const Icon = styled.img`
  width: ${props => props.width}px;
  height: ${props => props.height}px;
`;

const TotalKakaoSendWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-end;
  align-items: flex-end;

  margin-top: 16px;

  width: 100%;
  height: 41px;

  overflow: hidden;
`;

const KakaoSendWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-end;
  align-items: center;

  width: ${props => props.isClicked ? `100%` : `51px`};
  height: 100%;

  overflow: hidden;

  border-radius: ${props => props.isClicked ? `0px 0px 30px 30px` : `8px 0px 30px 0px`};
  background-color: #FFF9C3;

  transition: all 0.3s ease-in-out;
`;

const TotalSendInfoWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  margin: 0px 16px 0px 28px;

  width: 92.85%;
`;

const SendInfoWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: ${props => props.gap}px;
`;

const CheckBoxWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  white-space: nowrap;

  gap: 8px;

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const TotalTextWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 16px;
`;

const SendTextWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  white-space: nowrap;

  gap: 4px;
`;

const SendCheckBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 14px;
  height: 14px;

  border-radius: 16px;
  border: 1px solid ${props => props.theme.line};
  background-color: ${props => props.isClicked ? `#F9E000` : props.theme.subBackground};

  transition: all 0.3s ease-in-out;
`;

const KakaoSendButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 51px;
  height: 41px;
  min-width: 51px;
  min-height: 41px;
  max-width: 51px;
  max-height: 51px;

  border-radius: 8px 0px 30px 0px;
  background-color: ${props => props.isClicked ? `#F9E000` : `#FFF48D`};

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }

  transition: all 0.3s ease-in-out;
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  @media (hover: hover) {
    &:hover {
      cursor: ${props => props.cursor};
    }
  }
`;
